// extracted by mini-css-extract-plugin
export var timelineIntro = "timelineIntro-module--timelineIntro--Sa0u-";
export var timelineIntroText = "timelineIntro-module--timelineIntroText--EHJ0z";
export var fadeInTransform = "timelineIntro-module--fadeInTransform--3a346";
export var fadeInBlur = "timelineIntro-module--fadeInBlur--fu0i5";
export var fadeIn = "timelineIntro-module--fadeIn--ATEVC";
export var timelineLabel = "timelineIntro-module--timelineLabel--HXHzM";
export var subtitle = "timelineIntro-module--subtitle--Wgcda";
export var introTextParagraph = "timelineIntro-module--introTextParagraph--0ncaX";
export var isIE = "timelineIntro-module--isIE--OCrFn";
export var timelineIntroSpace = "timelineIntro-module--timelineIntroSpace--y8Oyg";
export var slideUp = "timelineIntro-module--slideUp--ZEkf2";
export var slideUpLarge = "timelineIntro-module--slideUpLarge--JTVgv";